import apiClient from '@/service/apiClient';

export type ReqGetLocationTop10 = {
  location: string;
};

export type ResGetLocationTop10 = {
  isSuccess: boolean;
  code: number;
  message: string;
  correlationId: string;
  result: Array<{
    id: number;
    name: string;
    location: string;
    categoryId: number;
    categoryName: string;
    villageName: string;
    price: number;
    originPrice: number;
    thumbnailUrl: string;
    productType: string;
    reservationCount: number;
  }>;
};

export const getLocationTop10 = async (location: string): Promise<ResGetLocationTop10> => {
  const { data } = await apiClient.get<ResGetLocationTop10>('/app/products/v2/location/top-10', {
    params: { location },
  });
  return data;
};
